module.exports = __webpack_public_path__ + "static/11-ba606f2562bb5d2547a6e27c1d7a2551.png";